import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './styles.sass';

const Captcha = props => (
  <div className={styles.captcha}>
    <ReCAPTCHA
      sitekey="6LdScnQUAAAAACG0AkA9z6gZtKmrL41amjeC9MJ0"
      onChange={response => props.input.onChange(response)}
    />
  </div>
);

export default Captcha;
